































































































































































































    import {Component, Vue, Watch} from 'vue-property-decorator';
    import HeaderNav from "@/components/header-nav/header-nav.vue";
    import {mapState} from 'vuex';
    // import { NProgress } from 'nprogress';
    import {MicroApps} from "@/micro-app";
    import router from "@/router";
    import authority from "@/../../common/src/assets/authority/authority";
    import shared from "@/shared";
    import SharedModule from "@/shared/index";
    import common from '../../common/src/assets/js/common';
    import service from '../../common/src/assets/service/service';
	import Constant from '../../common/src/assets/constant/constant';
	const moment = require('../../common/src/assets/moment/moment');
	declare var $: any;

    @Component({
        components: {HeaderNav},
    })
    export default class App extends Vue {
        private shared: any;
        private isLoading: boolean = true;
        private microApps: any = MicroApps.routes || [];
        private current: string = '/resource/';
		private noticeClauses = 0;
        private nav: any = {
            list: {
                vm: "/resource/vm/list",
                mirror: "/resource/mirror/list",
                ip: "/resource/ip/list",
                accountManagement: "/user",
                disk: "/resource/disk/list",
                vpc: '/resource/vpc/list',
                switch: "/resource/vswitch/list",
                routingTable: "/resource/route/list",
                nat: '/resource/nat/list',
				rds: '/resource/rds/list',
                snapshot: "/resource/snap/list",
                general: '/general',
                slb: '/resource/slb/list',
                securityGroup: '/resource/securityGroup/list',
                taskQueue: '/resource/taskQueue/list',
                moneyset: '/user/moneyset',
                payBill: '/user/payBill/list',
                voucherMange: '/user/voucherMange/list',
                bill: '/user/bill/list',
                dayConsume: '/user/dayConsume/list',
                message: '/user/message/message',
                'message-set': '/user/message/set',
                notice: '/user/message/notice',
                monthlyBill: '/user/monthlyBill/list',
                frontInfo: '/user/user/frontInfo',
                securitySettings: '/user/user/securitySettings',
                operateLog: '/user/userOptlog/list',
				authentication: '/authentication',
				authenticationinfo: '/authenticationinfo',
            },
            defaultActive: "",
            show: {
                overview: false,
                product: false,
                vm: false,
                mirror: false,
                storage: false,
                disk: false,
                snap: false,
                network: false,
                ip: false,
                vpc: false,
                vswitch: false,
                routeTable: false,
                nat: false,
				rds: false,
                slb: false,
                securityGroup: false,
                taks: false,
                userCenter: false,
                finance: true,
            }
        }

        private status: any = {
            page: 'full',	// 页面属性 {String} -- main:主项目|son:子项目 | full:全屏
        }
		public $store: any;
        private $router: any;
        private $route: any;
        private $authority: any;
        public userInfo: any = {};
        public systemInfo: any = {};
		private $layer: any

		// 公告
		private showBulletin: boolean = false;
		private showCustom: boolean = false;
		private optionsList: any = [];
		private optionsListValue: any = [];
		private time: any = {
			thisDay: ''
		};

		private newTime = new Date().getTime();
		private oldTime = new Date().getTime();
		private outTime = 1 * 60 * 60 * 1000; // 超时时间 1h

        @Watch('$route') changeRoute(to: any, from: any) {
			let menuType = to.path.split('/')[1];
			console.log('changeRoute', menuType)
            this.getPageStatus(menuType);
			// 检查是否后台跳转登录，处理登录信息
			let query = this.$route.query;
			if (to.name === 'General' && query.userID && query.ewalkToken && query.email) {
				this.getLoginInfo(query);
			} else if (common.getUserID()) { // 正常的路由切换
				this.getBulletinList();
				this.getUserInfo();
			}
        }

		private created() {
            this.shared = SharedModule;
            this.shared.$router = this.$router;
            this.getBrowserInfo();
        }

        private mounted() {
            /**整理页面 */
            let menuType = this.$route.path.split('/')[1];
            this.getPageStatus(menuType);
            this.getNavDefault();
            this.$router.beforeEach((to: any, from: any, next: any) => {
                this.getNavDefault();
                if (to.name === "General") {
                    this.getNavShow();
                }
                next();
            })
			// 获取时间
			this.time.thisDay = moment().format('YYYY-MM-DD HH:mm:ss');
			// 初始化权限部分
			this.initUserInfo();
			// 如果是子应用模块的，页面F5刷新，不会粗发changeRoute事件，需要获取一次用户和公告信息
			if(this.status.page === "son" && common.getUserID()){
				this.getUserInfo();
				this.getBulletinList();
			}
        }

        private select(index: any) {
            this.nav.defaultActive = index;
            this.$router.push(this.nav.list[index]);
        }

        private skip(index: any) {
            this.$router.push(this.nav.list[index]);
        }
	
	    /**后台来源跳转，获取登录信息 */
		private getLoginInfo(query:any) {
			let date = new Date();
			date.setTime(date.getTime() + (1 * 60 * 60 * 1000)); // 1h过期
			common.setCookie('front_userID', query.userID, date)
			common.setCookie('user', query.email, date)
			common.setCookie('front_ewalkToken', query.ewalkToken, date);
			// 监听鼠标长时间不操作
			// @ts-ignore
			document.addEventListener('mousemove', this.changeCookieTime(query.userID, query.ewalkToken, query.email))
			// this.changeCookieTime(query.userID, query.ewalkToken, query.email);
			let timer =  window.setInterval(() => {
				this.newTime = new Date().getTime();
				if (this.newTime - this.oldTime > this.outTime) { // 到时间
					this.$layer.msg('您已长时间没有操作，请重新登录！', {type: 'warning'});
					window.clearInterval(timer);
					setTimeout(() => {
						// @ts-ignore
						document.removeEventListener('mousemove', this.changeCookieTime('', '', ''))
						this.$router.push({path: '/login'});
					}, 2000)
				}
			}, 3000)
			common.resetUrl();
			this.initUserInfo();
			this.getUserInfo();
			this.getBulletinList();
		}
        /**监听鼠标长时间不操作 */
        private changeCookieTime(userID:any, ewalkToken:any, email?:any) {
            let that = this;
			let date = new Date();
			that.oldTime = date.getTime();
			date.setTime(date.getTime() + that.outTime); // 2h
			common.setCookie('front_userID', userID, date)
			common.setCookie('user', email, date)
			common.setCookie('front_ewalkToken', ewalkToken, date);
        }
		/**初始化用户权限信息 */
		private initUserInfo() {
            let token = common.getCookie('front_ewalkToken');
            if (!token) {
                service.createToken();
            }
            let userID = common.getUserID();
            if (!userID) {
                authority.getAuthority('superAdmin')
                this.getNavShow();
            } else {
                this.getAuthority();
            }
		}

		/**获取用户信息 */
        private getUserInfo() {
            let params = {
                userID: common.getUserID()
            }
			// 因为有点页面也会请求到这个接口，同一个接口1s呢请求1次以上后端会报错， 所以加个时间戳
            service.request('/user/queryCustomerInfo?t=' + new Date().getTime(), params, 'token').then((res: any) => {
                this.userInfo = res.data;
				this.$store.commit('setUserInfo', this.userInfo);
				this.$forceUpdate();
            }).catch((error: any) => {
                console.log(error)
            })
        }

        /**
         * 获取前台权限
         */
        private getAuthority() {
            let params = {
                userID: common.getUserID(),
            }
            service.request('/user/agentConfig/getSystemInfo?t=' + new Date().getTime(), params,).then((res: any) => {
                authority.getAuthority('superAdmin', res.data.resourceFunction)
				this.systemInfo = res.data || {};
				this.$store.commit('setSystemInfo', this.systemInfo);
                this.getNavShow();
            }).catch((error: any) => {
                authority.getAuthority([]);
            })
        }

        private getNavShow() {
            this.nav.show.snap = this.$authority.snap.fixedSnapList || this.$authority.snap.autoSnapList || this.$authority.snap.autoSnapConfigList || this.$authority.snap.backupRestoreRecordList || this.$authority.image.list;
            this.nav.show.storage = this.$authority.disk.list || this.nav.show.snap;
            this.nav.show.network = this.$authority.ip.list || this.$authority.vpc.list || this.$authority.vswitch.list || this.$authority.routeTable.list || this.$authority.nat.list || this.$authority.rds.list;;
            this.nav.show.product = this.$authority.vm.list || this.$authority.image.list || this.nav.show.storage || this.nav.show.network || this.$authority.slb.list || this.$authority.securityGroup.list || this.$authority.task.list;
            // this.nav.show.finance = this.$authority.cash.recharge || this.$authority.cash.list || this.$authority.voucher.list || this.$authority.chargesRecord.list || this.$authority.dailyBills.list || this.$authority
        }

        private getNavDefault() {
            let delay = setTimeout(() => {
                let router = window.location.pathname;
				this.nav.defaultActive = '';
                for (let i in this.nav.list) {
                    if (this.nav.list[i] === router) {
                        this.nav.defaultActive = i;
                    }
                }
                clearTimeout(delay)
            }, 300)

        }

        private getPageStatus(index: any) {
            if (['', 'register', 'resetPassword', 'login', 'payment'].indexOf(index) > -1) {
                this.status.page = "full";
            } else if (['general','authentication', 'authenticationinfo'].indexOf(index) > -1) {
                this.status.page = "main"
            } else {
                this.status.page = "son"
            }
            this.$forceUpdate();
        }

        private getBrowserInfo() {
            /**第一次访问我们主页的地址 */
            let firstVisit = window.location.href;
            if (!common.getCookie('firstVisit')) {
                common.setCookie('firstVisit', firstVisit);
            }

            /**来源 */
            let host = window.location.host;
            let sourceUrl = document.referrer; // 获取访问来源url
            let expireDate = new Date();
            expireDate.setTime(expireDate.getTime() + 43200 * 60 * 1000); // 30天过期
            if (!!sourceUrl && sourceUrl.indexOf(host) === -1 && sourceUrl.indexOf(service.apiPrefix) === -1) {
                // sourceUrl可能存在中文，需要编码后存在cookie，否则会乱码；注意读取时，需要解码decodeURIComponent
                common.setCookie('sourceUrl', encodeURIComponent(sourceUrl), expireDate);
            }
        }

		/**获取公告信息*/
		private getBulletinList(){
			let params = {
				userID: common.getUserID(),
			};
			service.request('/user/bulletin/query', params, 'token').then((res:any) => {
				console.log(res);
				this.optionsList = res.data.list;
				this.optionsListValue = [];
				this.optionsList.forEach((item: any) => {
					if (this.time.thisDay >= item.startTS && this.time.thisDay <= item.endTS) {
						item['showTimeIS'] = true;
						this.optionsListValue.push(item);
					} else {
						item['showTimeIS'] = false;
					}
				})
				document.getElementById('text-content')!.innerHTML = this.optionsListValue[0].content;
				console.log('this.optionsListValue', this.optionsListValue);
				let showBulletin = this.optionsList.some((item: any) => {
					return item.popupPageName === 'buyVM';
				})
				if (showBulletin && this.$route.path === '/resource/vm/create') {
					if (this.optionsListValue.length > 0) {
						this.showBulletin = true;
						this.showCustom = true;
					}
				} else {
					this.showBulletin = false;
					this.showCustom = false;
				}
				console.log('公告', this.optionsList)
			}).catch((error:any) => {

			})
		}

		private open() {
			this.showCustom = !this.showCustom;
			if (this.showCustom) {
				setTimeout(() => {
					this.optionsListValue.forEach((item: any, index: any) => {
						if (this.noticeClauses == index) {
							document.getElementById('text-content')!.innerHTML = item.content;
							this.$forceUpdate();
						}
					})
				})
			}
		}
		private cancel() {
			this.showCustom = false;
		}
		/**
		* Description: 点击上下公告
		* @param type: string, up | down
		* return void
		*/
		private clickNoticeUpAndDown(type: any) {
			if (type === 'up') {
				if (this.noticeClauses === 0) { return; }
				this.noticeClauses--;
			} else if (type === 'down') {
				if (this.noticeClauses === this.optionsListValue.length - 1) { return; }
				this.noticeClauses++;
			}
			document.getElementById('text-content')!.innerHTML = '';
			this.optionsListValue.forEach((item: any, index: any) => {
				if (this.noticeClauses == index) {
					document.getElementById('text-content')!.innerHTML = item.content;
				}
			})
		}
    }
